import { userService } from '../services';
import { alertActions } from './alert';
import { userinfoActions } from './userinfo';
import { history } from '../helpers';

const LOGIN_REQUEST = 'authentication/LOGIN_REQUEST';
const LOGIN_SUCCESS = 'authentication/LOGIN_SUCCESS';
const LOGIN_FAILURE = 'authentication/LOGIN_FAILURE';
const LOGOUT = 'authentication/LOGOUT';

const login = (username, password, keepLogon) => {
    return dispatch => {
        dispatch(request({ username }));

        userService.login(username, password, keepLogon)
            .then(
                user => {
                    dispatch(success(user));
                    dispatch(userinfoActions.getUserinfoById(username, keepLogon));
                    dispatch(alertActions.success('로그인 하였습니다.', '/home'));
                },
                error => {
                    dispatch(failure(error.toString()));
                    dispatch(alertActions.error(error.toString()));
                }
            );
    };

    function request(user) { return { type: LOGIN_REQUEST, user } }
    function success(user) { return { type: LOGIN_SUCCESS, user } }
    function failure(error) { return { type: LOGIN_FAILURE, error } }
};

const logout = () => {
    userService.logout();
    return { type: LOGOUT };
};

const portalaccess = (code, encStr, keepLogon) => {
    return dispatch => {
        dispatch(request({ code }));

        userService.portalaccess(encStr, keepLogon)
            .then(
                user => {
                    dispatch(success(user));
                    dispatch(userinfoActions.getUserinfoById(code, keepLogon));
                    history.push("/home");
                },
                error => {
                    dispatch(failure(error.toString()));
                    dispatch(alertActions.error(error.toString()));
                }
            )
    };

    function request(user) { return { type: LOGIN_REQUEST, user } }
    function success(user) { return { type: LOGIN_SUCCESS, user } }
    function failure(error) { return { type: LOGIN_FAILURE, error } }
};

export const authenticationActions = {
    login,
    logout,
    portalaccess
};

let user = "";
if (JSON.parse(localStorage.getItem('user'))) user = JSON.parse(localStorage.getItem('user'));
else if (JSON.parse(sessionStorage.getItem('user'))) user = JSON.parse(sessionStorage.getItem('user'));

const initialState = user ? { loggedIn: true, user } : {};

function authentication(state = initialState, action) {
    switch (action.type) {
        case LOGIN_REQUEST:
            return {
                loggingIn: true,
                user: action.user
            };
        case LOGIN_SUCCESS:
            return {
                loggedIn: true,
                user: action.user
            };
        case LOGIN_FAILURE:
            return {};
        case LOGOUT:
            return {};
        default:
            return state
    }
}

export default authentication;